import { IeLynxObject } from "../../common/models/eLynxObject";
import { ITagModel } from "../../common/models/ITagModel";
import { LiveDataCommandStateEnum, ILiveDataStatusModel } from "../../services/live-data-service/Models";

export type LiveDataStateItem = {
    eLynxObject: IeLynxObject;
    tags: ITagModel[];
    command: LiveDataActionType;
    commandState: LiveDataCommandStateEnum;
    commandComplete: boolean;
    commandFailed: boolean;
    message?: string;
    updatedOn?: Date | undefined;
    statusIDs?: string[] | undefined;
    status?: ILiveDataStatusModel | undefined;

    statusRetrieved?: boolean;
    messageDisplayed?: boolean;
};

export type LiveDataState = {
    items: LiveDataStateItem[];
};

export enum LiveDataActionType {
    DemandScan = 'DEMANDSCAN_COMMAND',
    CancelCommand = 'CANCEL_COMMAND',
    StatusChanged = 'STATUS_CHANGED',
    RemoveStatus = 'REMOVE_STATUS',
    WriteDown = 'WRITEDOWN_COMMAND',
    StateItemChanged = 'STATE_ITEM_CHANGED',
    TestChangeRegister = 'TEST_CHANGE_REGISTER',
    GetLiveStrokes = 'GET_LIVE_STROKES',
    GetPollingStatistics = 'GET_POLLING_STATISTICS'
};

export type DemandScanCommandType = {
    eLynxObject: IeLynxObject;
    statusIDs: string[];
};

export type WriteDownCommandType = {} & DemandScanCommandType;

export type TestChangeRegisterType = {} & DemandScanCommandType;

export type LiveStrokesCommandType = {} & DemandScanCommandType;

export type PollingStatisticsCommandType = {
    eLynxObject: IeLynxObject,
    statusIDs: string[]
}

export type CancelCommandType = {
    eLynxObject: IeLynxObject;
};

export type LiveDataAction = {
    type: LiveDataActionType.DemandScan;
    payload: DemandScanCommandType;
} | {
    type: LiveDataActionType.CancelCommand;
    payload: CancelCommandType;
} | {
    type: LiveDataActionType.StatusChanged;
    payload: ILiveDataStatusModel;
} | {
    type: LiveDataActionType.RemoveStatus;
    payload: ILiveDataStatusModel;
} | {
    type: LiveDataActionType.WriteDown;
    payload: WriteDownCommandType;
} | {
    type: LiveDataActionType.TestChangeRegister;
    payload: TestChangeRegisterType;
} | {
    type: LiveDataActionType.GetLiveStrokes;
    payload: LiveStrokesCommandType;
} | {
    type: LiveDataActionType.GetPollingStatistics;
    payload: PollingStatisticsCommandType;
} | {
    type: LiveDataActionType.StateItemChanged;
    payload: LiveDataStateItem;
};